module.exports = __webpack_public_path__ + "static/img/icon-coupon-guoqi.df295fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/icon-coupon-guoqi.png
// module id = 1633
// module chunks = 0